import Tile from './tile';
import common from '../common';

export default class grid {
	constructor(width, height) {
		this._tileDimensions = {
			width  : 4,
			height : 4
		};

		this._tiles = [];

		this._width = width;
		this._height = height;

		this.createGrid();
	}

	createGrid() {
		for (let x = 0; x < this._width; x++) {
			for (let y = 0; y < this._height; y++) {
				this._tiles.push(new Tile(this._tileDimensions, new THREE.Vector2(x, y), this));
			}
		}
	}

	getTileAt(x, y) {
		return this._tiles[(x * this._height) + y];
	}

	mapGrid() {
		const container = new PIXI.Container();

		for (let x = 0; x < this._width; x++) {
			for (let y = 0; y < this._height; y++) {
				const g = new PIXI.Graphics();
				const tile = this.getTileAt(x, y);
				const color = tile.isWall ? 0x00FF00 : 0xFFFFFF;
				const alpha = color === 0xFFFFFF ? 0.2 : 1;

				g.beginFill(color, alpha);
				g.drawRect(x * 8, y * 8, 8, 8);
				g.endFill();
				container.addChild(g);
			}
		}

		container.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5, 0);
		common.stage.addChild(container);

		return container;
	}

	get tiles() {
		return this._tiles;
	}

	get width() {
		return this._width;
	}

	get height() {
		return this._height;
	}

	get tileDimensions() {
		return this._tileDimensions;
	}
}
